module.exports = __webpack_public_path__ + "img/app-preview-card.fc96d7f5.png";